/**
 * One faceted filter group in the sidebar (Values, Authority, Philanthropy).
 * Renders section title + checkbox list. Same filter logic as top facets; sidebar styling.
 */
import React from "react";

export default function MListSidebarFilterGroup({ title, options, selectedIds, onChange, ariaLabel }) {
  const handleToggle = (id) => {
    const next = selectedIds.includes(id) ? selectedIds.filter((x) => x !== id) : [...selectedIds, id];
    onChange(next);
  };

  return (
    <div className="twentytwentysix-content__mlist-sidebar-facet-group" role="group" aria-label={ariaLabel || title}>
      <p className="twentytwentysix-content__mlist-sidebar-title">{title}</p>
      <div className="twentytwentysix-content__mlist-sidebar-facet-options">
        {options.map((opt) => (
          <label key={opt.id} className="twentytwentysix-content__mlist-sidebar-check">
            <input
              type="checkbox"
              checked={selectedIds.includes(opt.id)}
              onChange={() => handleToggle(opt.id)}
              aria-checked={selectedIds.includes(opt.id)}
            />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
